import { Bot } from 'lucide-react';


const TypingLoader = ({ className = '' }) => {
  return (
    <div className={`flex w-full h-fit gap-2 text-lg leading-7 ${className}`}>
      <div className="flex-1 mt-1 p-2 rounded-full bg-[#FA0041]/80 size-9 flex items-center justify-center grow-0">
          <Bot size={20} />
        </div>
      <div className="flex items-center space-x-1 mt-2">
        <div className="flex space-x-1">
          <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
        {/* <span className="ml-2 text-gray-500 text-sm">Thinkispan> */}
      </div>
    </div>
  );
};

export default TypingLoader; 